export const monitoringOptions = [
  {
    key: '1a',
    label: 'Review triangulation of information on mine sites',
  },
  {
    key: '2a',
    label: 'Review triangulation of information on supply chain actors',
  },
  {
    key: '3a',
    label: 'See where your information comes from',
  },
  {
    key: '4a',
    label: 'Monitor how your information is shared',
  },
  {
    key: '5a',
    label: 'Review information contributions from your sources',
  },
  {
    key: '6a',
    label: 'Review the performance of your information sources',
  },
  {
    key: '7a',
    label: 'Monitor information contributions over time',
  },
  {
    key: '8a',
    label: 'Consolidated contribution to the Sustainable Development Goals',
  },
  {
    key: '9a',
    label: 'Review the risk management activity and recommendations from all parties involved',
  },
  {
    key: '10a',
    label: 'Visualise locations on a map',
  },
  {
    key: '11a',
    label: 'Visualise incidents on a map',
  },
  {
    key: '12a',
    label: 'Visualise local information relays (LIR) on a map',
  },
  {
    key: '13a',
    label: 'Consolidated mine site risk map',
  },
];

export const supplyChainOptions = [
  {
    key: '1b',
    label: 'Visualise mineral supply chain selected for enhanced due diligence monitoring',
  },
  {
    key: '2b',
    label: 'Open map of included mine sites and key supply chain locations',
  },
  {
    key: '3b',
    label: 'Monitor supply chain risk assessment consolidated from all information sources',
  },
  {
    key: '4b',
    label: 'Consult the supply chain risk mitigation plan consolidated from all information sources',
  },
  {
    key: '5b',
    label: 'Assess risk related to mine sites included in the supply chain',
  },
  {
    key: '6b',
    label: 'Assess risk related to individual supply chain participants',
  },
  {
    key: '7b',
    label: 'Incidents reported by all information sources along the supply chain',
  },
  {
    key: '8b',
    label: 'Corrective actions reported in relation to the supply chain',
  },
  {
    key: '9b',
    label: 'Change your supply chain data settings',
  },
];
